export const loadScript = ({
  id,
  src,
  onLoad = () => {},
  onError = () => {},
  defer = null,
}) => {
  if (document.getElementById(id)) {
    onLoad();
    return;
  }
  let js = document.createElement("script");
  js.id = id;
  js.src = src;
  if (defer) {
    js.setAttribute("defer", "");
  }
  document.head.appendChild(js);
  js.onerror = onError;
  js.onload = onLoad;
};

export const KeyCodes = {
  Enter: (event) => event.key === "Enter",
};
